import { useContext } from 'react'
import { PreferencesContext } from './PreferencesContext'

export function useGetPreferences() {
  const context = useContext(PreferencesContext)

  if (!context) {
    throw new Error('useGetPreferences must be used within PreferencesProvider')
  }

  return context
}
